module.exports = __webpack_public_path__ + "img/streaming-mobile.3504599c.svg";